import React, { useContext } from 'react';
import styles from './DrawerTitle.module.scss';
import { H } from '../../H/H';
import DrawerContext from '../DrawerContext/DrawerContext';
export default function (_ref) {
  var children = _ref.children;
  var _useContext = useContext(DrawerContext),
    titleId = _useContext.titleId;
  return /*#__PURE__*/React.createElement(H, {
    id: titleId,
    className: styles.title
  }, children);
}